// removed by extract-text-webpack-plugin
module.exports = {"summary":"summary__qrCh_","funds":"funds__X-0jh","fund":"fund__2NA2e","image":"image__2ynZa","fund-name":"fund-name__2JBPb","edit":"edit__30Rbq","view-funds":"view-funds__2ppt2","hide":"hide__3HN7L"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/summaryOverview.scss
// module id = 237
// module chunks = 68